exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CategoryBadge_CategoryBadge__13hhs{position:relative;z-index:1;display:block;height:20px;padding:3px 6px;line-height:14px;font-size:12px;font-weight:700;margin-top:10px;margin-right:auto;margin-bottom:20px;word-break:break-word;color:#fff;-webkit-transform:translateY(2px);transform:translateY(2px)}@media only screen and (max-width:719px){.CategoryBadge_CategoryBadge__13hhs{display:block;margin-top:0;margin-bottom:20px;padding:3px 5px;font-size:11px;font-weight:400}}.CategoryBadge_CategoryBadgeNewLine__OBggV{background-color:#e47f00}.CategoryBadge_CategoryBadgeNewProducts__oaWN3{background-color:#42b4e6}.CategoryBadge_Card__IlpvR{position:absolute;left:-5px;z-index:8;-webkit-transform:translateY(0);transform:translateY(0)}.CategoryBadge_Card__IlpvR:before{content:\"\";position:absolute;bottom:-5px;left:0;width:0;height:0;border-style:solid;border-width:0 5px 5px 0;border-color:transparent}.CategoryBadge_Card__IlpvR.CategoryBadge_CategoryBadgeNewLine__OBggV:before{border-right-color:#b16300}.CategoryBadge_Card__IlpvR.CategoryBadge_CategoryBadgeNewProducts__oaWN3:before{border-right-color:#1d9fd8}@media only screen and (max-width:719px){.CategoryBadge_Card__IlpvR{margin:0;left:0}.CategoryBadge_Card__IlpvR:before{content:\"\";display:none}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"CategoryBadge": "CategoryBadge_CategoryBadge__13hhs",
	"CategoryBadgeNewLine": "CategoryBadge_CategoryBadgeNewLine__OBggV",
	"CategoryBadgeNewProducts": "CategoryBadge_CategoryBadgeNewProducts__oaWN3",
	"Card": "CategoryBadge_Card__IlpvR"
};